import { render, staticRenderFns } from "./payment-fail.component.vue?vue&type=template&id=393b4e64&scoped=true"
import script from "./payment-fail.component.ts?vue&type=script&lang=ts&external"
export * from "./payment-fail.component.ts?vue&type=script&lang=ts&external"
import style0 from "./payment-fail.component.vue?vue&type=style&index=0&id=393b4e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b4e64",
  null
  
)

export default component.exports